<template>
<div v-if="isPc">
     <el-row :gutter="20" type="flex" justify="center">
           <el-col :span="16">
                <el-row :gutter="20" type="flex" justify="center" v-for="index in 2" :key="index" :class="index==1? '': 'mt20'">
                        <el-col :span="8" v-for="(item, i) in aboutList.slice((index-1)*3,index*3)" :key="i"  align="center">
                        <div class="div-about-icon-image">
                            <el-image
                            :src="require(`@/assets/images/${item}.png`)"
                            class="about-icon-image image-transition-scale2">
                            </el-image>  
                            <div>
                            <p v-if="index==1 && i === 0" class="font-20">组织规模</p>
                            <p v-else-if="index==1 && i === 1" class="font-20">销售业绩</p>
                            <p v-else-if="index==1 && i === 2" class="font-20">能力范围</p>
                            <p v-else-if="index==2 && i === 0" class="font-20">行业覆盖</p>
                            <p v-else-if="index==2 && i === 1" class="font-20">客户数量</p>
                            <p v-else class="font-20">用户规模</p>
                            </div>
                            <div style="width:80%">
                            <p v-if="index==1 && i === 0" class="font-16 line-height-2">公司员工近百人，<br/> 素质高、学历高、能力强是我们的普遍特征</p>
                            <p v-else-if="index==1 && i === 1" class="font-16 line-height-2">累计销售额超亿元，连续保持高增长率，<br/>我们一直在创辉煌</p>
                            <p v-else-if="index==1 && i === 2" class="font-16 line-height-2">深耕钢铁领域多年，<br/>智能制造综合方案提供商</p>
                            <p v-else-if="index==2 && i === 0" class="font-16 line-height-2">行业覆盖钢铁领域及智能制造产业</p>
                            <p v-else-if="index==2 && i === 1" class="font-16 line-height-2">累计合作客户总量超过百家，<br/>众多企业都选择精益产品与服务</p>
                            <p v-else class="font-16 line-height-2">产品已在百家企业信息化项目上<br/>得到成功实施和应用</p>
                            </div>
                        </div>
                        </el-col>
                    </el-row>
           </el-col>
     </el-row>
</div>
<div v-else>
   <el-row :gutter="20"   justify="center" v-for="index in 3" :key="index" :class="index==1? '': 'mt20'">
        <el-col :span="12" v-for="(item, i) in aboutList.slice((index-1)*2,index*2)" :key="i"  align="center">
          <div class="div-about-icon-image">
             <el-image
              :src="require(`@/assets/images/${item}.png`)"
              class="about-icon-image image-transition-scale2">
            </el-image>  
            <div>
              <p v-if="index==1 && i === 0" class="font-20">组织规模</p>
              <p v-else-if="index==1 && i === 1" class="font-20">销售业绩</p>
              <p v-else-if="index==2 && i === 0" class="font-20">能力范围</p>
              <p v-else-if="index==2 && i === 1" class="font-20">行业覆盖</p>
              <p v-else-if="index==3 && i === 0" class="font-20">客户数量</p>
              <p v-else class="font-20">用户规模</p>
            </div>
            <div style="width:60%">
              <p v-if="index==1 && i === 0" class="font-14 line-height-2">公司员工近百人， 素质高、学历高、能力强</p>
              <p v-else-if="index==1 && i === 1" class="font-14 line-height-2">累计销售额2亿元，连续保持高增长率</p>
              <p v-else-if="index==2 && i === 0" class="font-14 line-height-2">深耕钢铁领域多年，智能制造综合方案提供商</p>
              <p v-else-if="index==2 && i === 1" class="font-14 line-height-2">行业覆盖各中大型钢铁冶金领域，智能制造方向</p>
              <p v-else-if="index==3 && i === 0" class="font-14 line-height-2">累计合作客户总量超过百家，众多企业都选择精益</p>
              <p v-else class="font-14 line-height-2">产品已在百家企业信息化项目上得到成功实施和应用</p>
            </div>
          </div>
        </el-col>
     </el-row>
</div>
</template> 

<script>
export default {
   name:"AboutList",
   data(){
    return {
      isPc:true,
      aboutList: ["about_icon_1", "about_icon_2", "about_icon_3", "about_icon_4","about_icon_5", "about_icon_6"]// 关于图标
    }
   },
   created(){
      this.isPc = this.$store.state.isPc;
   }
}
</script>>

<style scoped>
@import "../../style/main.css";
 .div-about-icon-image {
  height: 255px;
  width: 100%;
  overflow: hidden;
  /* border: 1px solid #f4f4f6; */
   border-radius: 5px;  
  padding: 20px 0 10px 0;
  box-shadow: 0 6px 20px 0 #d7e8ff;
  background-color: #fff;
}
.about-icon-image {
  width: 60px;
  height: 60px;
  /* border-radius: 50%; */
}

.div-about-icon-image:hover .about-icon-image  {
  transform: scale(1.3, 1.3);
  color: #000;
}
.div-about-icon-image:hover {
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.3);
}
</style>>
 